
import { tzFetch, HOST} from "../../../utils/http";

//send OTP
export function getReceipt(params = {}) {
  return tzFetch(`${HOST}/fapi/gateway/view-receipt2?_id=`+ params, 'GET');
}